import { jsonp } from 'vue-jsonp'
import { ZipCloudResponse } from '@/interface/api'

const prefix = 'https://zipcloud.ibsnet.co.jp/api/search'

export const getZipCode = (zipcode: string): Promise<ZipCloudResponse[]> =>
  jsonp(`${prefix}?zipcode=${zipcode}`).then(response => response.results)
